import React from 'react';
import { Link } from '@mui/material';
import errorSrc from './error.svg';
import NoticePageLayout from '../NoticePageLayout';

type ErrorLayoutProps = {
  title?: React.ReactNode;
  body?: React.ReactNode;
};

export default function ErrorPage({
  title = 'Sorry, something went wrong on our end!',
  body,
}: ErrorLayoutProps) {
  return (
    <NoticePageLayout
      title={title}
      body={
        body || (
          <>
            In the meantime, you can refresh the page, come back later, or get in touch with us at{' '}
            <Link color="secondary" href="mailto:support@motivohealth.com" underline="hover">
              support@motivohealth.com
            </Link>
          </>
        )
      }
      imageSrc={errorSrc}
    />
  );
}
